import * as React from "react";
import useSWR from "swr";
import { useDispatch } from "../globalState";
import { actionCreators } from "../reducer";
import fetcher from "./fetcher";
import { IDENTITY_KEY } from "./identityKey";

const SIGNED_OUT = {};
const UNAUTHORIZED = 401;

export default function useIdentity() {
  const dispatch = useDispatch();
  const { data, error } = useSWR(IDENTITY_KEY, fetcher, {
    revalidateOnFocus: true,
  });
  const signedOut = error?.status === UNAUTHORIZED;
  const user = signedOut ? SIGNED_OUT : data?.data;

  React.useEffect(() => {
    if (user) dispatch(actionCreators.createSetUser(user));
  }, [user, dispatch]);
}
